module.exports = __webpack_public_path__ + "media/flags/mq-a0067ab9.svg";